<template>
  <div class="exchange-content">
    <!-- <div class="integral">
      积分
      <b>{{ number }}</b>
    </div> -->
    <div class="integral-list">
      <van-tabs
        v-model="active"
        line-width="80"
        title-active-color="#D80A68"
        @change="chooseCate"
      >
        <van-tab title="积分收支明细"   name="积分收支明细">
          <div class="del">
            <div class="tabs">
              <span
                v-for="(item, index) in tabList"
                :key="index"
                :class="index === chooseIndex ? 'active' : ''"
                @click="chooseTab(index)"
                >{{ item }}</span
              >
            </div>
            <div class="integral-count">
              <span>{{
                chooseIndex === 0
                  ? "未使用"
                  : chooseIndex === 1
                  ? "已获取":chooseIndex === 2? "已使用":"取消兑换"
              }}</span>
              <b>{{
                chooseIndex === 0
                  ? number
                  : chooseIndex === 1
                  ? totalNumber
                  :chooseIndex === 2
                  ?totalNumber - number: ''
              }}</b>
            </div>
            <ul>
              <li v-for="(item, index) in integralList" :key="index">
                <div class="title" v-if="item.kind === '已获取' ">
                  <div class="left">
                    <em>{{getIntegralSource(item)}}</em>
                    <b>{{ item.activityName }}</b>
                  </div>
                  <div class="right">
                    <span>+{{ item.integral }}</span>
                  </div>
                </div>
                <div class="order-no">
                  <p v-if="item.kind === '已获取'">
                    {{ item.productName }}-{{ item.skuName }}
                  </p>
                  
                  <p v-if="['已使用','取消兑换','清空'].includes(item.kind)">{{ item.code || "-" }}</p>
                  <!-- item.kind === '取消兑换'?'+'+item.integral:item.integral -->
                  <span v-if="['已使用','取消兑换','清空'].includes(item.kind)">{{ item.integral>0 ? `+${item.integral}`:item.integral }}</span>
                </div>
                <div class="date">
                  <span>{{ new Date(item.createAt).toLocaleString() }}</span>
                  <span v-if="item.kind !=='已获取'">{{getIntegralSource(item)}}</span>
                </div>
              </li>
            </ul>
          </div>
        </van-tab>
        <van-tab title="积分兑换记录"  name="积分兑换记录">
          <div class="list">
            <ul>
              <li v-for="(item, index) in changeList" :key="index">
                <div class="state" :class="item.state == 1 || item.state == 9?'disabble':''">
                  {{ item.state == 1 ? "未支付" : item.state == 2?"支付成功":'已取消' }}
                </div>
                <div
                  class="top"
                  v-for="(product, i) in item.productList"
                  :key="i"
                >
                  <img :src="product.image" alt="" />
                  <div class="product-name">
                    <p class="name">
                      {{ product.productName }}{{ product.skuName }}
                    </p>
                    <div class="num">
                      <p>
                        <span>数量：{{ product.count }}</span>
                        <span>价格：{{ product.integral }}积分</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="bottom">
                  <!-- <p>物流状态: 物流配送中您的订单由第…</p> -->
                  <p></p>
                  <span @click="goDel(item)">查看详情</span>
                  <span class="cancle" @click="cancle(item)" v-if="item.state == 1"
                    >取消订单</span
                  >
                </div>
              </li>
            </ul>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <ToBack />
  </div>
</template>

<script>
import http from "../common/http.js";
import ToBack from "./common/toback.vue";
export default {
  components: { ToBack },
  data() {
    return {
      active: "积分收支明细",
      tabList: ["全部", "已获取", "已使用",'取消兑换'],
      chooseIndex: 0,
      changeList: [],
      integralList: [],
      newList: [],
      totalNumber: null,
      number: null,
    };
  },
  mounted() {
    this.getIntegral("");
    if(this.$route.query.type==2){
      this.active="积分兑换记录"
      this.getChangeIntegral();
    }
  },
  methods: {
    // 积分收支明细
    getIntegral(kind) {
      http
        .get("/integral/public/integrallog/getlist?kind=" + kind)
        .then((res) => {
          this.integralList = res.data;
          this.totalNumber = res.totalNumber;
          this.number = res.number;
        });
    },
    // 积分兑换明细
    getChangeIntegral() {
      http.get("/integral/public/exchange/list").then((res) => {
        this.changeList = res.data;
      });
    },
    chooseTab(index) {
      this.chooseIndex = index;
      this.getIntegral(index === 0 ? "" : this.tabList[index]);
    },
    goDel(item) {
      this.$router.push("/orderDel?data=" + JSON.stringify(item));
    },
    //取消订单
    cancle(item){
      http.post("/integral/public/closed/exchange/"+item._id).then((res) => {
        this.$toast(res.message);
        this.getChangeIntegral()
      });
    },
    chooseCate(val) {
      console.log(val,'val')
      if (val === "积分兑换记录") {
        this.getChangeIntegral();
      }
    },
    getIntegralSource(info){
      const sourceObj={
        "已获取":'获取',
        "已使用":"使用",
        "取消兑换":"取消",
        "清空":"清空"
      }
      return sourceObj[info.kind]
    }
  },
};
</script>

<style lang="scss" scoped>
.state {
  font-size: 12px;
  color: #40c8b0;
  line-height: 17px;
  text-align: right;
  margin-bottom: 10px;
  &.disabble{
    color: #b1b5c1;
  }
}
.exchange-content {
  padding: 12px;
  .integral {
    width: 100%;
    height: 68px;
    line-height: 68px;
    padding-left: 27px;
    b {
      font-size: 36px;
      font-weight: bold;
      color: #d80a68;
    }
  }

  .integral-list {
    background: #fff;
    border-radius: 10px !important;
    .del {
      background: #fff;
      padding: 15px;
      border-top: 1px solid #f3f6fd;
      border-radius: 10px;
      .tabs {
        span {
          display: inline-block;
          padding: 0 13px;
          height: 25px;
          line-height: 25px;
          background: #f3f6fd;
          border-radius: 4px;
          color: #b1b5c1;
          font-size: 14px;
          margin-right: 10px;
          &.active {
            background: #d80a68;
            color: #fff;
          }
        }
      }
      .integral-count {
        font-size: 18px;
        font-weight: bold;
        margin: 30px 0 5px 0;
        span {
          margin-right: 10px;
        }
        b {
          color: #d80a68;
        }
      }
      ul {
        border-radius: 10px;
        li {
          padding: 15px 0;
          border-bottom: 1px solid #f3f6fd;
          &:last-child {
            border: none;
          }
          .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .left {
              display: flex;
              align-items: center;
              em {
                display: inline-block;
                width: 28px;
                height: 16px;
                border-radius: 2px;
                color: #d80a68;
                background: rgba(216, 10, 104, 0.1);
                text-align: center;
                line-height: 16px;
                margin-right: 5px;
                font-size: 11px;
              }
              b {
                font-size: 16px;
              }
            }
            .right {
              span {
                color: #d80a68;
                font-size: 16px;
                &.active {
                  color: #666666;
                }
              }
              i {
                display: inline-block;
                width: 10px;
                height: 10px;
                background: url("../image/yky/箭头.png") no-repeat;
                background-size: contain;
              }
            }
          }
          .order-no {
            display: flex;
            justify-content: space-between;
            color: #999999;
            margin-top: 3px;
            p {
              line-height: 18px;
            }
            span {
              margin-right: 5px;
            }
          }
          .date {
            color: #999999;
            display:flex;
            justify-content:space-between;
          }
        }
      }
    }

    .list {
      border-top: 1px solid #f3f6fd;
      ul {
        background: #fff;
        padding: 20px 15px;
        border-radius: 10px;
        li {
          background: #f7f9fd;
          padding: 5px 10px 15px 5px;
          border-radius: 12px;
          margin-bottom: 10px;
          .top {
            display: flex;
            margin-bottom: 10px;
            img {
              width: 70px;
              height: 70px;
              background: #e9e9e7;
              border-radius: 6px;
              margin-right: 10px;
            }
            .product-name {
              flex: 1;
              position: relative;
              .name {
                font-size: 16px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                overflow: hidden;
                -webkit-line-clamp: 2;
              }
              .num {
                width: 100%;
                position: absolute;
                bottom: 0;
                color: #999999;
                p {
                  display: flex;
                  justify-content: space-between;
                }
              }
            }
          }
          .bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            justify-content: center;
            margin-top: 2px;
            p {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            span {
              display: block;
              width: 80px;
              height: 23px;
              border: 1px solid #d80a68;
              color: #d80a68;
              font-size: 14px;
              border-radius: 12px;
              margin-left: 24px;
              text-align: center;
              line-height: 23px;
            }
            .cancle{
              color: #7DB8DCFF;
              border-color:#7DB8DCFF;
            }
          }
        }
      }
    }

    >>> .van-tabs {
      border-radius: 10px !important;
    }
    >>> .van-tabs__wrap {
      border-radius: 10px !important;
    }
  }
}
>>> .van-tabs__nav {
  border-radius: 10px !important;
}
</style>